import { X } from "lucide-react";
import { useEffect } from "react";

/**
 * Aviso passageiro com uma ação — o "Desfazer" do descarte (2026-09-21).
 *
 * É a resposta ao pedido de tirar o pop-up de confirmação: a ação
 * acontece na hora, e a confirmação vira a chance de voltar atrás. O
 * aviso some sozinho depois de `durationMs`; passar o mouse não
 * segura, porque a ação já foi feita e nada depende do aviso ficar.
 * `role="status"`: o leitor de tela anuncia sem roubar o foco.
 */
export function Toast({
  message,
  actionLabel,
  onAction,
  onClose,
  durationMs = 8000
}: {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  onClose: () => void;
  durationMs?: number;
}) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, durationMs);
    return () => window.clearTimeout(timer);
  }, [onClose, durationMs]);

  return (
    <div className="toast" role="status" aria-live="polite">
      <span className="toast-message">{message}</span>
      {actionLabel && onAction && (
        <button type="button" className="toast-action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
      <button type="button" className="toast-close" onClick={onClose} aria-label="Fechar aviso">
        <X size={14} />
      </button>
    </div>
  );
}
